// removed by extract-text-webpack-plugin
module.exports = {"tutorialVersionSelector":"tutorialVersionSelector--1Psa7"};